module.exports = __webpack_public_path__ + "img/io.b9d0c2ff.svg";